import { Card } from 'antd';
import React from 'react';

const EmptyListMessage = ({ text }) => {
  return <Card className="text-center bold line-height-2 color-secondary"> {text} </Card>;
};

export default EmptyListMessage;
